export const UPDATE_GEO = 'UPDATE_GEO';

export const updateGeo = (geo) => ({
    type: UPDATE_GEO,
    payload: geo,
});
